import * as React from 'react';
import Modal from 'react-modal';

import DeviceSettingsItemTemplate from './DeviceSettingsItemTemplate';
import { DeviceSettingsDevice } from '../DeviceSettings';
import EnableOrDisableDeviceMutationContainer from 'settings/containers/EnableOrDisableDeviceMutationContainer';
import Link from 'components/Link';
import ResendConfirmationSMS from 'settings/components/ResendConfirmationSMS';
import LinkConstants from 'constants/LinkConstants';
import RemoveDeviceFromUserConfirmDialog from 'settings/components/RemoveDeviceFromUserConfirmDialog';
import TextWithIcon from 'components/TextWithIcon';
import TooltipTrigger from 'components/TooltipTrigger';
import LinkDeviceVerificationCodeBoxDialog from 'user/components/LinkDeviceVerificationCodeBoxDialog';

export type Props = {
  SMSDevice: DeviceSettingsDevice;
  deviceIsOnlyLoginDevice: boolean;
  isRosteredEnforcement: boolean;
  refetch: () => void;
};

type State = {
  confirmRemoveDialogIsOpen: boolean;
  linkDeviceVerificationCodeBoxDialogIsOpen: boolean;
};

export default class DeviceSettingsSMSItem extends React.Component<Props, State> {
  state = {
    confirmRemoveDialogIsOpen: false,
    linkDeviceVerificationCodeBoxDialogIsOpen: false,
  };

  showConfirmRemoveDialog = () => {
    this.setState({ confirmRemoveDialogIsOpen: true });
  };

  hideConfirmRemoveDialog = () => {
    this.setState({ confirmRemoveDialogIsOpen: false });
  };

  showSMSConfirmationDialog = () => {
    this.setState({ linkDeviceVerificationCodeBoxDialogIsOpen: true });
  };

  hideSMSConfirmationDialog = () => {
    this.setState({ linkDeviceVerificationCodeBoxDialogIsOpen: false });
  };

  renderSecondaryText = () => {
    const { SMSDevice } = this.props;
    const { reachabilityInfo, confirmed } = SMSDevice;

    if (confirmed) {
      return 'Text messages';
    } else if (reachabilityInfo && reachabilityInfo.reasonShort && reachabilityInfo.reasonLong) {
      return (
        <Link
          href={LinkConstants.UNREACHABLE_DEVICES}
          target="_blank"
          data-test="unreachable-device-link">
          <TooltipTrigger placement="left" tooltip={reachabilityInfo.reasonLong}>
            <TextWithIcon icon="explanation-circle" iconColor="apple" gutter="xxsmall">
              {reachabilityInfo.reasonShort}
            </TextWithIcon>
          </TooltipTrigger>
        </Link>
      );
    } else {
      return (
        <span data-test="unverified-secondary-text">
          Pending confirmation.{' '}
          <ResendConfirmationSMS sms={SMSDevice} onShowDialog={this.showSMSConfirmationDialog}>
            Resend code
          </ResendConfirmationSMS>
        </span>
      );
    }
  };

  render() {
    const { SMSDevice, deviceIsOnlyLoginDevice, isRosteredEnforcement } = this.props;

    return (
      <React.Fragment>
        <Modal data-test="remove-sms-device-modal" isOpen={this.state.confirmRemoveDialogIsOpen}>
          <RemoveDeviceFromUserConfirmDialog
            deviceName={SMSDevice.label || 'Your device'}
            deviceId={SMSDevice.id}
            onRequestHide={this.hideConfirmRemoveDialog}
          />
        </Modal>
        <Modal
          data-test="resend-email-modal"
          isOpen={this.state.linkDeviceVerificationCodeBoxDialogIsOpen}>
          <LinkDeviceVerificationCodeBoxDialog
            deviceName={SMSDevice.label || 'Your device'}
            deviceType="phoneNumber"
            onDone={this.props.refetch}
            onRequestHide={this.hideSMSConfirmationDialog}
          />
        </Modal>
        <EnableOrDisableDeviceMutationContainer>
          {enableOrDisableDevice => (
            <DeviceSettingsItemTemplate
              deviceType="sms"
              deviceExists
              deviceIsRostered={SMSDevice.rostered && isRosteredEnforcement}
              deviceIsEnabled={SMSDevice.enabled}
              deviceIsOnlyLoginDevice={deviceIsOnlyLoginDevice}
              deviceCanBeEnabledOrDisabled
              primaryTextLabel={SMSDevice.label}
              secondaryTextLabel={this.renderSecondaryText()}
              onRemoveDevice={this.showConfirmRemoveDialog}
              onEnableOrDisableDevice={() =>
                enableOrDisableDevice({
                  variables: { deviceId: SMSDevice.id, enabled: !SMSDevice.enabled },
                })
              }
            />
          )}
        </EnableOrDisableDeviceMutationContainer>
      </React.Fragment>
    );
  }
}
